/**
 * useMetrics — derives metrics from raw email data using metricsEngine.
 */

import { useMemo } from 'react';
import { processEmails } from '../engine/metricsEngine';

export function useMetrics(rawData) {
  const metrics = useMemo(() => {
    if (!rawData) return null;
    return processEmails(rawData);
  }, [rawData]);

  return metrics;
}
